import React, {useCallback, useEffect, useState, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router'
import Lottie from 'react-lottie';
import cn from 'classnames';
// import { isEmpty } from 'lodash';

import leftLayer from './img/left-test.png';
import rightLayer from './img/right.png';
import leftMan from './img/leftman.png';
import rightMan from './img/rightman.png';
import weaponsIcon from './img/weapons.png';
import whitelistIcon from './img/whitelist-icon.png';
import rightArrow from './img/right-arrow.png';
// import minted from './img/mintedBg.png';
import mintNone from './img/plus.png';
import noneBg from './img/none-bg.svg';
import bloodBg from './img/Items/amateur/Circle_Blood.png';

import amateurSparkle from '../../lotties/amateur_sparkle.json';
import assassinSparkle from '../../lotties/assassin_sparkle.json';
import survivorSparkle from '../../lotties/survivor_sparkle.json';
import killerSparkle from '../../lotties/killer_sparkle.json';
import loadingData from '../../lotties/loading.json';

import Swiper from './Swiper';
import MintStepModal from './MintSteps';
import useCountDown from './useCountdown';
import useMintedList from './useMintedList';

import Nav from '../Home/LandingPageHeader/Header';
import CountDown from '../../components/CountDown';

import Animations from '../../components/Animations';
// import useRefresh from '../../hooks/useRefresh';

import {
    setIsMobile,
    setIsTablet,
    setIsDesktop,
    toggleWalletModal
} from '../../actions/common';
// import { fetchAllSettings } from '../../actions/setting';

import
    Wrapper,
    {
        BubbleLayer,
        HeaderBanner,
        Document,
        MyArsenal,
        MintContent
    }
from './styles';

const BREAKPOINTS = {
    SM_MAX: 767,
    MD_MIN: 768,
    MD_MAX: 1023,
    LG_MIN: 1024,
    LG_MIN_CUSTOM: 1279
};

function MintWeapons() {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();

    const { pathname = '' } = location;

    const [mintStarted, setMintStarted] = useState(false);
    const [currentItem, setCurrentItem] = useState({});
    const [offset, setOffset] = useState(0);

    const {
        isMobile,
        isTablet,
        isDesktop,
        isEndCountdown
    } = useSelector(state => state.common);

    const isConnected = useSelector(state => state.user.connectWallet.isConnect);
    const mintListLoading = useSelector(state => state.ownership?.ownershipsRes?.requesting);
    const { data = [] } = useSelector(state => state.setting?.allSettings?.result ?? []);
    const { loadingConnectAccount } = useSelector(state => state.user ?? false);

    /* USED TO GET TOTAL MINTED */
    // const { afterMinted } = useSelector(state => state.ownership);
    // const { slowRefresh } = useRefresh();

    const getTimeStamp = data.find(e => e.key === 'startTime');

    // USE HOOKS
    const { mintedList = [], hasMore, firstLoad } = useMintedList({ offset, isConnected, isEndCountdown });
    const { timer } = useCountDown({ timeStamp: getTimeStamp?.value });

    const onResize = useCallback(() => {
        if ((window.innerWidth < BREAKPOINTS.MD_MIN) && !isMobile) {
            dispatch(setIsMobile())
        } else if ((window.innerWidth > BREAKPOINTS.SM_MAX) && (window.innerWidth < BREAKPOINTS.LG_MIN_CUSTOM) && !isTablet) {
            dispatch(setIsTablet())
        } else if ((window.innerWidth > BREAKPOINTS.LG_MIN_CUSTOM) && !isDesktop) {
            dispatch(setIsDesktop())
        }
    }, [dispatch, isMobile, isTablet, isDesktop]);

    // LISTEN LOAD MORE
    const observer = useRef();
    const lastElement = useCallback(node => {
        if (mintListLoading) return;

        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver(entries => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && hasMore) {
                    setOffset(prevState => prevState + 10);
                }
            });
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0.5
        });

        if (node) observer.current.observe(node);
    }, [mintListLoading, hasMore]);

    useEffect(() => {
        onResize();
        window.addEventListener('onload', onResize);
        window.addEventListener('resize', onResize);

        return () => {
            window.removeEventListener('resize', onResize);
            window.removeEventListener('onload', onResize);
        }
    }, [onResize, dispatch]);

    useEffect(() => {
        loadingConnectAccount && setOffset(0);
    }, [loadingConnectAccount]);

    // useEffect(() => {
    //     dispatch(fetchAllSettings());
    // }, [dispatch]);

    const renderLottieSparkle = (name) => {
        if (!name) return amateurSparkle;
        if (name === 'AMATEUR') return amateurSparkle;
        if (name === 'ASSASSIN') return assassinSparkle;
        if (name === 'SURVIVOR') return survivorSparkle;
        if (name === 'ZOMBIE KILLER') return killerSparkle;

        return amateurSparkle;
    };

    const renderHeaderBanner = () => (
        <HeaderBanner>
            <div className="image-layout">
                <section className="left-layer">
                    <img src={leftMan} alt="left" className="left-header" />
                    <div className="left-overlay" />
                </section>

                <section className="right-layer">
                    <img src={rightMan} alt="right" className="right-header" style={{ paddingRight: 20 }} />
                    <div className="right-overlay" />
                </section>

                <div className="overlay" />
            </div>
        </HeaderBanner>
    );

    const renderBubbleLayer = () => (
        <BubbleLayer>
            <section className="bubble">
                <img src={leftLayer} alt="left" className="left" />
                <div className="left-bubble" />
            </section>
            <section className="bubble">
                <img src={rightLayer} alt="right" className="right" />
                <div className="right-bubble" />
            </section>
        </BubbleLayer>
    );

    const renderDocument = () => (
        <Document>
            <div className="box">
                <img src={isEndCountdown ? weaponsIcon : whitelistIcon} alt="icon" className="left" />

                <section className="center">
                    {/* <h2>
                        {isEndCountdown
                            ? 'Introducing the Undead Blocks Weapon Whitelist Program'
                            : 'Learn more about Undead Blocks Weapons Minting'
                        }
                    </h2> */}

                    <h2>INTRODUCING THE WEAPONS MINTING GUIDE</h2>
                    <p>Read our Medium guide and learn how minting works.</p>

                    {/* <p>
                        {isEndCountdown
                            ? 'Read our Medium post to learn more about our whitelist.'
                            : 'Learn more about weapon loadouts on our official Medium article.'
                        }
                    </p> */}
                </section>

                <a
                    href="https://medium.com/@UndeadBlocks/undead-blocks-call-to-arms-weapons-minting-guide-f7b48c72ef23"
                    target="_blank"
                    rel="noreferrer"
                    className="read-btn"
                >
                    <p>Read Article</p>
                    <img src={rightArrow} alt="arrow" />
                </a>
            </div>
        </Document>
    );

    const renderMyArsenal = () => {
        return (
            <MyArsenal>
                <h2 className="title">My Weapons</h2>
                <p className="description">Weapon Loadouts found in your connected wallet will appear here</p>

                <div className="mint-list">
                    {firstLoad ? (
                        new Array(isMobile ? 2 : 3).fill({}).map((e, i) => (
                            <div
                                key={i}
                                className="loading"
                            >
                                <div className="heading-loading" />

                                <div className="content-loading" />

                                <div className="footer-loading">
                                    <section className="left-loading" />
                                    <section className="right-loading" />
                                </div>
                            </div>
                        ))
                    ) : (
                        mintedList && [...mintedList, {}, {}].map((e, i) => (
                            <div
                                key={i}
                                className={cn('mint-item', {
                                    'nope': !e.id,
                                    'border': e.id
                                })}
                                ref={mintedList.length === i + 1 ? lastElement : null}
                            >
                                {!e?.id ? (
                                    <div className="no-content">
                                        <img
                                            src={noneBg}
                                            style={{ width: '100%' }}
                                            alt="border"
                                        />
                                        <img
                                            src={mintNone}
                                            alt="none"
                                            className="none"
                                            onClick={() => handleOnTop()}
                                        />
                                    </div>
                                ) : (
                                    <MintContent
                                        style={{ background: `url(${e.thumbnail}) no-repeat center center / cover` }}
                                        onClick={() => {
                                            history.push(`/nft/${e?.contractAddress}/${e?.tokenId}`)
                                        }}
                                    >
                                        <div className="info">
                                            <Lottie
                                                options={{
                                                    loop: true,
                                                    autoplay: true,
                                                    animationData: renderLottieSparkle(e.title)
                                                }}
                                                style={{
                                                    transition: `height 0.05s`,
                                                    position: 'absolute',
                                                    zIndex: 70
                                                }}
                                                height={isMobile ? '315.5rem' : '205.5rem'}
                                                isClickToPauseDisabled={true}
                                            />
                                        </div>
                                    </MintContent>
                                )}


                                {/* {!e.title ? (
                                    <div className="no-content">
                                        <img
                                            src={noneBg}
                                            style={{ width: '100%' }}
                                            alt="border"
                                        />
                                        <img
                                            src={mintNone}
                                            alt="none"
                                            className="none"
                                            onClick={() => handleOnTop()}
                                        />
                                    </div>
                                ) : (
                                    <MintContent
                                        title={e.title}
                                        fontSizeWeb={e.fontSize}
                                        fontSizeMobile={e.fontSizeMobile}
                                        onClick={() => {
                                            console.log('e :', e)
                                            history.push(`/nft/${e?.contractAddress}/${e?.tokenId}`)
                                        }}
                                    >
                                        <div className="top">
                                            <h2 className="heading">{e.title}</h2>
                                        </div>
    
                                        <div className="info">
                                            <img src={bloodBg} alt="bg" className="mintBg" />
    
                                            {!isEmpty(e.assets?.Knife) && (
                                                <img
                                                    src={e.assets?.Knife}
                                                    alt="knife"
                                                    className={cn('knife', {
                                                        'amateurKnife': e.title === 'AMATEUR',
                                                        'survivorKnife': e.title === 'SURVIVOR',
                                                        'assassinKnife': e.title === 'ASSASSIN',
                                                        'killerKnife': e.title === 'ZOMBIE KILLER',
                                                        'rookieKnife': e.title === 'ROOKIE',
                                                        'commanderKnife': e.title === 'COMMANDER',
                                                        'veteranKnife': e.title === 'VETERAN'
                                                    })}
                                                />
                                            )}
    
                                            {!isEmpty(e.assets?.Pistol) && (
                                                <img
                                                    src={e.assets?.Pistol}
                                                    alt="pistol"
                                                    className={cn('pistol', {
                                                        'amateurPistol': e.title === 'AMATEUR',
                                                        'survivorPistol': e.title === 'SURVIVOR',
                                                        'assassinPistol': e.title === 'ASSASSIN',
                                                        'killerPistol': e.title === 'ZOMBIE KILLER',
                                                        'rookiePistol': e.title === 'ROOKIE',
                                                        'commanderPistol': e.title === 'COMMANDER',
                                                        'veteranPistol': e.title === 'VETERAN'
                                                    })}
                                                />
                                            )}
    
                                            {!isEmpty(e.assets['DB']) && (
                                                <img
                                                    src={e.assets['DB']}
                                                    alt="short"
                                                    className={cn('shortGuns', {
                                                        'amateurShort': e.title === 'AMATEUR',
                                                        'survivorShort': e.title === 'SURVIVOR',
                                                        'assassinShort': e.title === 'ASSASSIN',
                                                        'killerShort': e.title === 'ZOMBIE KILLER',
                                                        'rookieShort': e.title === 'ROOKIE',
                                                        'commanderShort': e.title === 'COMMANDER',
                                                        'veteranShort': e.title === 'VETERAN'
                                                    })}
                                                />
                                            )}

                                            {!isEmpty(e.assets['BaseballBat']) && (
                                                <img
                                                    src={e.assets['BaseballBat']}
                                                    alt="short"
                                                    className={cn('shortGuns', {
                                                        'amateurShort': e.title === 'AMATEUR',
                                                        'survivorShort': e.title === 'SURVIVOR',
                                                        'assassinShort': e.title === 'ASSASSIN',
                                                        'killerShort': e.title === 'ZOMBIE KILLER',
                                                        'rookieShort': e.title === 'ROOKIE',
                                                        'commanderShort': e.title === 'COMMANDER',
                                                        'veteranShort': e.title === 'VETERAN'
                                                    })}
                                                />
                                            )}

                                            {!isEmpty(e.assets['RPG']) && (
                                                <img
                                                    src={e.assets['RPG']}
                                                    alt="short"
                                                    className={cn('shortGuns', {
                                                        'amateurShort': e.title === 'AMATEUR',
                                                        'survivorShort': e.title === 'SURVIVOR',
                                                        'assassinShort': e.title === 'ASSASSIN',
                                                        'killerShort': e.title === 'ZOMBIE KILLER',
                                                        'rookieShort': e.title === 'ROOKIE',
                                                        'commanderShort': e.title === 'COMMANDER',
                                                        'veteranShort': e.title === 'VETERAN'
                                                    })}
                                                />
                                            )}

                                            {!isEmpty(e.assets['M1A']) && (
                                                <img
                                                    src={e.assets['M1A']}
                                                    alt="long"
                                                    className={cn('longGuns', {
                                                        'amateurLong': e.title === 'AMATEUR',
                                                        'survivorLong': e.title === 'SURVIVOR',
                                                        'assassinLong': e.title === 'ASSASSIN',
                                                        'killerLong': e.title === 'ZOMBIE KILLER',
                                                        'rookieLong': e.title === 'ROOKIE',
                                                        'commanderLong': e.title === 'COMMANDER',
                                                        'veteranLong': e.title === 'VETERAN'
                                                    })}
                                                />
                                            )}
    
                                            {!isEmpty(e.assets['F1']) && (
                                                <img
                                                    src={e.assets['F1']}
                                                    alt="long"
                                                    className={cn('longGuns', {
                                                        'amateurLong': e.title === 'AMATEUR',
                                                        'survivorLong': e.title === 'SURVIVOR',
                                                        'assassinLong': e.title === 'ASSASSIN',
                                                        'killerLong': e.title === 'ZOMBIE KILLER',
                                                        'rookieLong': e.title === 'ROOKIE',
                                                        'commanderLong': e.title === 'COMMANDER',
                                                        'veteranLong': e.title === 'VETERAN'
                                                    })}
                                                />
                                            )}
    
                                            {!isEmpty(e.assets['AKM']) && (
                                                <img
                                                    src={e.assets['AKM']}
                                                    alt="long"
                                                    className={cn('longGuns', {
                                                        'amateurLong': e.title === 'AMATEUR',
                                                        'survivorLong': e.title === 'SURVIVOR',
                                                        'assassinLong': e.title === 'ASSASSIN',
                                                        'killerLong': e.title === 'ZOMBIE KILLER',
                                                        'rookieLong': e.title === 'ROOKIE',
                                                        'commanderLong': e.title === 'COMMANDER',
                                                        'veteranLong': e.title === 'VETERAN'
                                                    })}
                                                />
                                            )}
    
                                            {!isEmpty(e.assets['MP5']) && (
                                                <img
                                                    src={e.assets['MP5']}
                                                    alt="long"
                                                    className={cn('longGuns', {
                                                        'amateurLong': e.title === 'AMATEUR',
                                                        'survivorLong': e.title === 'SURVIVOR',
                                                        'assassinLong': e.title === 'ASSASSIN',
                                                        'killerLong': e.title === 'ZOMBIE KILLER',
                                                        'rookieLong': e.title === 'ROOKIE',
                                                        'commanderLong': e.title === 'COMMANDER',
                                                        'veteranLong': e.title === 'VETERAN'
                                                    })}
                                                />
                                            )}

                                            {!isEmpty(e.assets['R870']) && (
                                                <img
                                                    src={e.assets['R870']}
                                                    alt="long"
                                                    className={cn('longGuns', {
                                                        'amateurLong': e.title === 'AMATEUR',
                                                        'survivorLong': e.title === 'SURVIVOR',
                                                        'assassinLong': e.title === 'ASSASSIN',
                                                        'killerLong': e.title === 'ZOMBIE KILLER',
                                                        'rookieLong': e.title === 'ROOKIE',
                                                        'commanderLong': e.title === 'COMMANDER',
                                                        'veteranLong': e.title === 'VETERAN'
                                                    })}
                                                />
                                            )}
    
                                            {!isEmpty(e.assets?.Perk) && (
                                                <img
                                                    src={e.assets?.Perk}
                                                    alt="perks"
                                                    className={cn('perks')}
                                                />
                                            )}

                                            {!isEmpty(e.assets?.Axe) && (
                                                <img
                                                    src={e.assets?.Axe}
                                                    alt="axe"
                                                    className={cn('axe')}
                                                />
                                            )}
    
                                            <Lottie
                                                options={{
                                                    loop: true,
                                                    autoplay: true,
                                                    animationData: renderLottieSparkle(e.title)
                                                }}
                                                style={{
                                                    transition: `height 0.05s`,
                                                    position: 'absolute',
                                                    zIndex: 70
                                                }}
                                                height={isMobile ? '315.5rem' : '205.5rem'}
                                                isClickToPauseDisabled={true}
                                            />
                                        </div>
    
                                        <div className="bottom">
                                            <p className="detail">
                                                {e.description}
                                            </p>
                                            <div
                                                style={{
                                                    background: `url(${minted}) no-repeat center center / cover`
                                                }}
                                                className="mint-btn"
                                            >
                                                <Link to={`/nft/${e.tokenId}`} className="view-lbl">
                                                    View Details
                                                </Link>
                                            </div>
                                        </div>
                                    </MintContent>
                                )} */}
                            </div>
                        ))
                    )}
                </div>

                {!firstLoad && mintListLoading && (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            paddingBottom: '80rem'
                        }}
                    >
                        <div className="loading-more">
                            <Animations animationData={loadingData} />
                        </div>
                    </div>
                )}
            </MyArsenal>
        )
    }

    const handleOnTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    return (
        <Wrapper>
            <Nav isStaking />
            {renderBubbleLayer()}
            {renderHeaderBanner()}

            {!isEndCountdown ? (
                <CountDown timer={timer} />
            ) : (
                <div
                    className={cn('', {
                        'notShow': !isEndCountdown
                    })}
                >
                    <Swiper
                        bloodBg={bloodBg}
                        pathname={pathname}
                        isConnected={isConnected}
                        toggleWalletModal={() => dispatch(toggleWalletModal(true))}
                        setMintStarted={setMintStarted}
                        setCurrentItem={setCurrentItem}
                    />
                </div>
            )}

            {renderDocument()}
            {renderMyArsenal()}

            <MintStepModal
                item={currentItem}
                isVisible={mintStarted}
                onCancel={() => setMintStarted(false)}
                isMobile={isMobile}
                isTablet={isTablet}
                isDesktop={isDesktop}
            />
        </Wrapper>
    );
}

export default MintWeapons;